import { useMsal } from '@azure/msal-react';
import { trackEvent } from '../ApplicationInsights';
import { currentUserService } from '../subjects/common/CurrentUserService';

function useAuth() {
    const { instance: msalInstance } = useMsal();

    const logout = (eventName = 'AVA-UI-Logout') => {
        if (!msalInstance || !msalInstance.logoutRedirect) {
            throw new Error('Unable to logout. No valid instance of MSAL was found.');
        }

        trackEvent(eventName);
        currentUserService.logout();
        sessionStorage.removeItem('access_token');
        msalInstance.logoutRedirect();
    };

    return {
        logout,
    };
}

export default useAuth;
